import { defineComponent, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { WidgetApiServiceTypes } from '@/types/widgetApiService';
import { numberFormat } from '@/utils/helpers';
import useTransactionsStore from '../../store/modules/transactions';
import RateTimer from '../general/RateTimer.vue';
import RateRefreshedAlert from '../general/RateRefreshedAlert.vue';
export default defineComponent({
    name: 'SellOrderSummaryComponent',
    components: {
        RateTimer,
        RateRefreshedAlert,
    },
    setup() {
        const transactionStore = useTransactionsStore();
        const { selectedCurrency, selectedCurrencyAmount, selectedCrypto, selectedCryptoAmount, usdRate, currentRate, networkFee, loading, channel, serviceFee, serviceFeeUSD, selectedFiatAmountWithoutFees, } = storeToRefs(transactionStore);
        const showRateAlert = ref(false);
        const onNewRateReceived = () => {
            showRateAlert.value = true;
            setTimeout(() => {
                showRateAlert.value = false;
            }, 5000);
        };
        const changePaymentProvider = () => {
            // navigate back
        };
        const onKeyPress = (event) => {
            event.preventDefault();
        };
        return {
            selectedCrypto,
            onNewRateReceived,
            selectedCurrency,
            selectedCurrencyAmount,
            selectedCryptoAmount,
            numberFormat,
            usdRate,
            currentRate,
            networkFee,
            showRateAlert,
            loading,
            channel,
            WidgetApiServiceTypes,
            changePaymentProvider,
            onKeyPress,
            serviceFeeUSD,
            serviceFee,
            selectedFiatAmountWithoutFees,
        };
    },
});
